/**
 * Region Selector JavaScript for SuperGold Rails
 * 
 * This module handles the location dropdown functionality in the search bar,
 * including region selection, district dropdown display, and location text updates.
 * 
 * Features:
 * - Dynamic district dropdown based on selected region
 * - Bootstrap 5 modal integration
 * - Proper event handling and state management
 * - URL parameter updates with page reload
 * - Search query preservation across location changes
 * - Accessibility support
 */

const region_selector = '.js-region-selector select';
let district_selector = '.js-district-selector';

// Initialize on DOM ready
$(function() {
  initializeRegionSelector();
});

/**
 * Initialize the region selector functionality
 * Sets up event handlers and modal integration
 */
function initializeRegionSelector() {
  // Set up event handlers immediately to ensure they're available
  setupRegionChangeHandler();
  
  // Handle modal shown event to update state when modal opens
  $('#locationModal').on('shown.bs.modal', function() {
    // Update the display based on current selection when modal opens
    displaySelectedDistrict();
  });

  // Handle location selection when "Done" button is clicked
  $('.js-location-selector').on('click', function() {
    updateLocationDisplay();
  });
}

/**
 * Set up the region change handler
 * Uses namespaced events to prevent duplicate bindings
 */
function setupRegionChangeHandler() {
  // Remove any existing handlers to prevent duplicate bindings
  $(region_selector).off('change.regionSelector');
  
  // Bind the change handler with namespace for easy removal
  $(region_selector).on('change.regionSelector', function() {
    hideAllDistricts();
    displaySelectedDistrict();
  });
}

/**
 * Get the currently selected region
 * @returns {jQuery} jQuery object for the selected region option
 */
function updateSelectedRegion() {
  return $(region_selector + ' :selected');
}

/**
 * Hide all district selectors and disable their select elements
 */
function hideAllDistricts() {
  $(district_selector).addClass('d-none').hide();
  $(district_selector + ' select').attr('disabled', true);
}

/**
 * Display the district selector for the currently selected region
 * Uses Bootstrap 5 utility classes for show/hide functionality
 */
function displaySelectedDistrict() {
  const selected_region = updateSelectedRegion();
  const region_value = selected_region.val();
  
  if (region_value) {
    const target_district_selector = $(district_selector + '[data-region-name="' + region_value + '"]');
    
    // Show the district selector for the selected region
    target_district_selector.removeClass('d-none').show();
    target_district_selector.find('select').removeAttr('disabled');
  }
}

/**
 * Update the location display text when "Done" is clicked
 * Handles both region-only and district-specific selections
 * Also updates the URL parameters to reflect the current selection
 * Preserves any existing search query in the search input field
 */
function updateLocationDisplay() {
  const selected_region = updateSelectedRegion();
  const region_value = selected_region.val();
  
  // Get current URL parameters
  const url = new URL(window.location);
  const params = url.searchParams;
  
  // Preserve search query if it exists in the search input field
  // Try multiple possible selectors for the search input
  const searchInput = $('input[name="query"], input[type="search"], input[aria-label="Search offers"]').first();
  const currentQuery = searchInput.val();
  if (currentQuery && currentQuery.trim() !== '') {
    params.set('query', currentQuery.trim());
  }
  
  // Default to "All of New Zealand" if no region selected
  if (!region_value) {
    $('.js-location-selected').text('All of New Zealand');
    
    // Clear location parameters from URL but preserve query
    params.delete('menu[region]');
    params.delete('menu[district]');
    updateBrowserUrl(url);
    return;
  }
  
  const selected_district = $(district_selector + '[data-region-name="' + region_value + '"] select :selected');
  const district_value = selected_district.val();
  const all_districts_selected = !district_value || district_value === '' || selected_district.text().includes(`All ${selected_region.text()} districts`);
  
  // Update URL parameters based on selection
  params.set('menu[region]', region_value);
  
  // Show region name if no district or "All districts" selected, otherwise show district name
  if (selected_district.length === 0 || all_districts_selected) {
    $('.js-location-selected').text(selected_region.text());
    
    // Remove district parameter if not selected or "All districts" selected
    params.delete('menu[district]');
  } else {
    $('.js-location-selected').text(selected_district.text());
    
    // Set district parameter
    params.set('menu[district]', district_value);
  }
  
  updateBrowserUrl(url);
}

/**
 * Update the browser URL and reload the page
 * @param {URL} url - The URL object with updated parameters
 */
function updateBrowserUrl(url) {
  // Navigate to the new URL, which will reload the page with the updated location parameters
  window.location.href = url.toString();
}
